import { useBottomSheetTimingConfigs } from '@gorhom/bottom-sheet';
import { Easing } from 'react-native-reanimated';

export const ORDER_SHEET_EASING = Easing.out(Easing.cubic);

/** Short ease-out slide for the sheets that open from the View Order bar. */
export const useOrderSheetMotion = () =>
  useBottomSheetTimingConfigs({ duration: 250, easing: ORDER_SHEET_EASING });
